import ArrowDownLg from "./arrow-down-lg.svg";
import Check from "./check.svg";

export const WhiteIcons = {
  ArrowDownLg,
  Check,
};
